// The chat a checkout link was sent from: the agent adds `?src=` (default
// "whatsapp") to the links it sends, so the express cart can offer a way back
// to that conversation. WhatsApp opens links in a pop-up browser (a Chrome
// Custom Tab or Safari View Controller) that a page can't detect on its own.

import { getApiUrl } from "@/lib/config";

export function linkSource(search: string = window.location.search): string | null {
  return new URLSearchParams(search).get("src");
}

/**
 * A brand link's WhatsApp chat: the public link redirect (GET /v1/r/{slug}),
 * which opens wa.me with the brand's number and the link's prefill message.
 */
export function brandLinkChatUrl(slug: string): string {
  return getApiUrl(`/r/${encodeURIComponent(slug)}`);
}

/**
 * Where "Back to WhatsApp" goes: the brand's chat link when the page has one,
 * otherwise WhatsApp itself (the brand's number isn't known).
 */
export function whatsAppReturnUrl(chatUrl: string | null | undefined): string {
  return chatUrl || "https://wa.me/";
}

/**
 * What a shopper with a cart but no WhatsApp conversation sends to pick it up
 * in WhatsApp. The agent matches this wording to attach their WhatsApp number
 * to the session (mastra-agent: src/lib/cart-claim.ts), so keep the two in step.
 */
export function cartQuestionMessage(sessionId: string): string {
  return `Hi, I have some questions about my cart: ${sessionId}`;
}

/** The brand's WhatsApp chat (wa.me/{number}) with the cart question pre-filled. */
export function sessionChatUrl(brandChatUrl: string, sessionId: string): string {
  const url = new URL(brandChatUrl);
  url.searchParams.set("text", cartQuestionMessage(sessionId));
  return url.toString();
}
